import { useDownloadActions } from '../DownloadMenu'

export const useProjectMenu = () => {
  const switcher = useDownloadActions('file', 'download')

  const onClick = (keys: string[]) => switcher.run(keys)

  return { onClick }
}
